<template>
    <a :href="link" class="inline-flex items-center text-primary-500 hover:text-primary-600 font-semibold transition-colors group cursor-pointer">
        <span class="mr-2">{{ text }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="w-4 h-4 group-hover:translate-x-1 transition-transform">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
        </svg>
    </a>
</template>

<script setup>
const props = defineProps({
    text: {
        type: String,
        required: true
    },
    link: {
        type: String,
        required: false
    }
})
</script>